import React, { useState, useEffect } from 'react'
import GenericFormHeaderComponent from '../forms/GenericFormHeaderComponent'
import Icons from '../../assets/icons'
import useCustomToast from '../../hooks/useCustomToast';
import {
    EmailIcon,
    FacebookIcon,
    InstapaperIcon,
    LinkedinIcon,
    TelegramIcon,
    WhatsappIcon,
    EmailShareButton,
    FacebookMessengerShareButton,
    InstapaperShareButton,
    LinkedinShareButton,
    TelegramShareButton,
    WhatsappShareButton,
    TwitterShareButton,
    // ThreadsShareButton
    PinterestShareButton
    
} from "react-share";
import GenericCustomButton from '../GenericCustomButton';
import { CheckCheck, Link, X } from 'lucide-react';

const GenericFileShareModal = (props) => {

    const getButton = (key)=>{
        switch (key) {
            case 'Whatsapp':
                return <div className='group h-[50px] w-[50px] flex items-center justify-center rounded-full'>
                    <Icons.WhatsappIcon className='group-hover:hidden'/>
                    <Icons.WhatsappIconFilled className='hidden group-hover:block'/>
                </div>
                break;

            case 'Email':
                return <div className='group h-[50px] w-[50px] flex items-center justify-center rounded-full'>
                    <Icons.MailIcon className='group-hover:hidden'/>
                    <Icons.MailIconFilled className='hidden group-hover:block'/>
                </div>
                break;
        
            case 'Facebook':
                return <div className='group h-[50px] w-[50px] flex items-center justify-center rounded-full'>
                    <Icons.FacebookIcon className='group-hover:hidden'/>
                    <Icons.FacebookIconFilled className='hidden group-hover:block'/>
                </div>
                break;
        
            case 'Instapaper':
                return <div className='group h-[50px] w-[50px] flex items-center justify-center rounded-full'>
                    <Icons.InstaPaperIcon className='group-hover:hidden'/>
                    <Icons.InstaPaperIconFilled className='hidden group-hover:block'/>
                </div>
                break;
        
            case 'Linkedin':
                return <div className='group h-[50px] w-[50px] flex items-center justify-center rounded-full'>
                    <Icons.LinkedInIcon className='group-hover:hidden'/>
                    <Icons.LinkedInIconFilled className='hidden group-hover:block'/>
                </div>
                break;
        
            case 'Telegram':
                return <div className='group h-[50px] w-[50px] flex items-center justify-center rounded-full'>
                    <Icons.TelegramIcon className='group-hover:hidden'/>
                    <Icons.TelegramIconFilled className='hidden group-hover:block'/>
                </div>
                break;
        
            case 'Twitter':
                return <div className='group h-[50px] w-[50px] flex items-center justify-center rounded-full'>
                    <Icons.TwitterIcon className='group-hover:hidden'/>
                    <Icons.TwitterIconFilled className='hidden group-hover:block'/>
                </div>
                break;
        
            case 'Threads':
                return <div className='group h-[50px] w-[50px] flex items-center justify-center rounded-full'>
                    <div className='h-full w-full flex items-center justify-center rounded-full bg-[#0000000D] group-hover:bg-black'>
                        <Icons.ThreadsIcon height={34} className='group-hover:hidden'/>
                        <Icons.ThreadsIconWhite height={34} className='hidden group-hover:block'/>
                    </div>
                </div>
                break;

            case 'Pinterest':
                return <div className='group h-[50px] w-[50px] flex items-center justify-center rounded-full'>
                    <Icons.PinterestIcon className='group-hover:hidden'/>
                    <Icons.PinterestIconFilled className='hidden group-hover:block'/>
                </div>
                break;
        
            default: <></>
                break;
        }
    }

    const [successMessage, setSuccessMessage] = useState("");
    let Buttons = { 
        "Email": EmailShareButton, 
        "Whatsapp": WhatsappShareButton,
        "Facebook": FacebookMessengerShareButton, 
        "Linkedin": LinkedinShareButton, 
        "Telegram": TelegramShareButton, 
        "Twitter": TwitterShareButton, 
        "Instapaper": InstapaperShareButton, 
        // "Threads": ThreadsShareButton
        "Pinterest": PinterestShareButton
        
    }
    let IconList = { 
        "Whatsapp": getButton('Whatsapp'), 
        "Email": getButton('Email'), 
        "Facebook": getButton('Facebook'), 
        "Instapaper": getButton('Instapaper'), 
        "Linkedin": getButton('Linkedin'), 
        "Telegram": getButton('Telegram'), 
        "Twitter" : getButton("Twitter"),
        // "Threads" : getButton("Threads")
        "Pinterest" : getButton("Pinterest")
    }
    // Function to copy the url of the content to the clipboard
    const copyToClipboard = () => {
        navigator.clipboard.writeText(props?.fileUrl);
        setSuccessMessage(true);
    }

    useEffect(() => {
        if (successMessage)
            setTimeout(() => {
                setSuccessMessage(false);
            }, 3000)
    }, [successMessage])

    return (
        // <React.Fragment>
        //     <GenericFormHeaderComponent
        //         label={{
        //             contentPrimary: "Share File",
        //         }}
        //         closeModal={props.closeModal}
        //     />
        //     <div className="share-file py-2.5 px-[15px]">    
        //         <h3 className='text-sm font-bold text-[#21314b] mb-[5px]'>Copy File URL</h3>
        //         <div className="sf-data">
        //             <div className='flex items-center justify-end'>
        //                 {successMessage && <span className='text-[11px] font-medium text-white bg-black py-1 px-2.5 rounded-[35px] mr-[3px]'>Copied</span>}
        //                 <button className='p-[5px] border border-transparent hover:border-[#707494]' onClick={() => copyToClipboard()}>
        //                     <Icons.CopyIcon />
        //                 </button>
        //             </div>
        //             <p className='text-xs leading-[18px] font-medium text-[#21314b] m-[0]' id={`copyShareDataContent`}>
        //                 {props?.fileUrl}
        //             </p>
        //         </div>
        //         {/* Render all the share options available to the user  */}
        //         <div className='sf-icons flex flex-wrap pt-[20px]'>
        //             {Object.keys(Buttons)?.map(key => {
        //                 let Icon = IconList?.[key];
        //                 let Component = Buttons?.[key]
        //                 return <div className='sfi mr-[10px]'>
        //                     <Component url={props.fileUrl}>
        //                         <Icon />
        //                     </Component>
        //                 </div>
        //             })}
        //         </div>
        //     </div>
        // </React.Fragment>
        <div className='shareMediaModal p-[15px]'>
            <div className='w-full flex items-center justify-end'>
                <GenericCustomButton
                    onClick={props.closeModal}
                    disabled={false}
                    loading={false}
                    leftIcon={<div className='flex items-center gap-2'><span className='text-[11px]'>Esc</span> <div className='h-[12px] w-[1px] shrink-0 bg-black'></div></div>}
                    rightIcon={<X size={19} className='ml-2' />}
                    className='ml-1 flex items-center justify-center hover:opacity-75'
                />
            </div>
            <div className='p-[15px]'>

                <h2 className='mb-5 text-xl font-semibold text-fontBlack text-center'>Share Link Via</h2>

                <div className='px-8'>
                    <div className='px-[32px] py-[20px] pb-[16px] mb-4 grid grid-cols-4 gap-x-0 gap-y-3.5 place-items-center border border-[#C7D3DF] rounded-[10px]'>
                        {Object.keys(Buttons)?.map(key => {
                            let Icon = IconList?.[key];
                            let Component = Buttons?.[key]
                            return <div className='sfi'>
                                <Component media={props.fileUrl} url={props.fileUrl}>
                                    {/* <Icon /> */}
                                    {Icon}
                                </Component>
                            </div>
                        })}
                    </div>
                </div>

                <p className='mb-2.5 text-[13px] text-[#575D6A] text-center'>OR</p>

                <div className='w-full'>
                    <label className='gib-label-heading w-full'>Copy File URL</label>
                    <div className='p-[8px] h-[37px] w-full flex items-center border border-[#A6A8AC] rounded-[3px]'>
                        <div className='w-full max-w-[calc(100%-24px)] flex items-center gap-1.5'>
                            <Link size={17} strokeWidth={1.5} className='shrink-0' />
                            <p className='mb-0 w-full h-full max-w-[290px] text-[11px] text-[#111D31] whitespace-nowrap overflow-x-auto scrollbar-hidden'>{props?.urlOnly || props?.fileUrl || ''}</p>  
                        </div>
                        <GenericCustomButton
                            type={successMessage ? '' :'primary'}
                            size='large'
                            label={successMessage ? 'Copied' : 'Copy'}
                            leftIcon={successMessage ? <CheckCheck size={15} color='white' strokeWidth={2.5} className='shrink-0' /> : <Icons.CopyIconWhite className='shrink-0'/>}
                            onClick={() => copyToClipboard()}
                            className={`!min-w-[80px] w-[80px] relative left-[8px] ${successMessage ? 'copyBtn h-[36px] text-xs font-medium text-white flex items-center justify-center gap-1.5 rounded-[3px] border-[#20BF6B] bg-[#20BF6B]' : ''}`}
                        />
                    </div>
                </div>

            </div>

        </div>
    )
}

export default GenericFileShareModal